import MojitoCore from 'mojito/core';
import MainSportsbookImpl from './main-sportsbook.js';
const UIControllerView = MojitoCore.Presentation.UIControllerView;

export default UIControllerView('MainSportsbook', MainSportsbookImpl);
